import styled from 'styled-components';

const Row = styled.div`
  flex: 1;
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Spacer = styled.div`
  flex: 1;
`;

export default Row;
